import { type CSSObject } from '@emotion/react';
import { type ContactListItemVariant } from './contact-list-item';

export const unknownContactNameTextSizeByVariant: Record<ContactListItemVariant, 'small' | 'medium'> = {
  standard: 'small',
  group: 'medium',
};

export const unknownContactGroupVariantStyles: CSSObject = {
  height: 'auto',
  paddingTop: 'var(--fabric-number-n-1-5-px)',
  paddingBottom: 'var(--fabric-number-n-1-5-px)',
  textAlign: 'left',
};

export const unknownContactItemBaseStyles: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'var(--fabric-number-n-2-px)',
  width: '100%',
  maxWidth: '100%',
  height: 40,
  borderBottom: '1px solid var(--fabric-color-neutral-10)',
};

export const unknownContactItemNormalStyles: CSSObject = {
  padding: 'var(--fabric-number-n-2-px) var(--fabric-number-n-4-px)',
};

export const unknownContactItemSmallStyles: CSSObject = {
  padding: 'var(--fabric-number-n-1-px) var(--fabric-number-n-2-px)',
};

export const unknownContactContentStyles: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--fabric-number-n-2-px)',
  minWidth: 0,
};
